import React from "react";

const questionData = (t) => { return [
    {
        question:t("faq_question1"),
        answer:t( "faq_answer1")
    },
    {
        question:t("faq_question2"),
        answer:t( "faq_answer2")
    },
    {
        question:t("faq_question3"),
        answer:t( "faq_answer3")
    },
    {
        question:t("faq_question4"),
        answer:t( "faq_answer4")
    },
    {
        question:t("faq_question5"),
        answer:t( "faq_answer5")
    },
    {
        question:t("faq_question6"),
        answer:t( "faq_answer6")
    },
    {
        question:t("faq_question7"),
        answer:t( "faq_answer7")
    },
    {
        question:t("faq_question8"),
        answer:t( "faq_answer8")
    },
    {
        question:t("faq_question9"),
        answer:t( "faq_answer9")
    },
    {
        question:t("faq_question10"),
        answer:t( "faq_answer10")
    },
    {
        question:t("faq_question11"),
        answer:t( "faq_answer11")
    },
    {
        question:t("faq_question12"),
        answer:t( "faq_answer12")
    },
    {
        question:t("faq_question13"),
        answer:t( "faq_answer13")
    },
    {
        question:t("faq_question15"),
        answer:t( "faq_answer15")
    },
    {
        question:t("faq_question15"),
        answer:t( "faq_answer15")
    },
];
}
export default questionData;